import { Injectable } from '@angular/core';
declare var bootstrap: any;
@Injectable({
  providedIn: 'root',
})
export class ToastService {
  showSuccess(message: string) {
    const toastElement = document.getElementById('successToast');
    const messageElement = document.getElementById('successToastMessage');
    if (toastElement && messageElement) {
      messageElement.innerText = message;
      const toast = new bootstrap.Toast(toastElement, { delay: 3000 });
      toast.show();
    }
  }

  showError(message: string) {
    const toastElement = document.getElementById('errorToast');
    const messageElement = document.getElementById('errorToastMessage');
    if (toastElement && messageElement) {
      messageElement.innerText = message;
      const toast = new bootstrap.Toast(toastElement, { delay: 3000 });
      toast.show();
    }
  }
}
